/**
 * logout.js — Utilitário de logout seguro
 * Revoga o token no servidor antes de limpar o localStorage.
 */

import { clearAuthSession, getAuthSession } from './authStorage';

export async function fazerLogout(navigate) {
  try {
    const { token } = getAuthSession();
    if (token) {
      await fetch('/api/logout', {
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + token },
      });
    }
  } catch (_) {
    // Falha silenciosa — limpa o localStorage de qualquer forma
  } finally {
    clearAuthSession();
    if (navigate) navigate('/');
  }
}
